import { Box, Button, Tab, Tabs, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import useErrorHandler from '../../../api/errorHandler/useErrorHandler';
import { useLocation } from 'react-router-dom';
import ProjectOverView from './Project_OverView';
import CalenderRangeButton from '../../common/CalenderRangeButton';
import ProjectCounters from './Project_Counters';
import dayjs from 'dayjs';
import { useApplicationContext } from '../../../context/ApplicationContext';


class ProjectDashboard_Tabs {
    static overview = "Overview";
    static scrum = "Daily Scrum";
    static tasks = "Tasks";
    static kanban = "Kanban";
    static sprint = "Sprint";
    static tracebility = "Tracebility";
    static counters = "Counters";
    static csat = "CSAT";
    static defect = "Defect";
}

export default function ProjectDashboardContainer() {
    const { activeDashboardModule, setActiveDashboardModule } = useApplicationContext();

    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation().pathname;


    const [dashboardType, setDashboardType] = useState("public");



    const [selectedDate, setSelectedDate] = useState({
        startDate: dayjs(),
        endDate: dayjs().add(6, 'day'),
    });

    const [activeProjectDashboard, setActiveProjectDashboard] = useState(ProjectDashboard_Tabs.overview);
    const [tabsList, setTabsList] = useState([
        ProjectDashboard_Tabs.overview,
        ProjectDashboard_Tabs.counters,
        ProjectDashboard_Tabs.scrum,
        ProjectDashboard_Tabs.tasks,
        ProjectDashboard_Tabs.kanban,
        ProjectDashboard_Tabs.sprint,
        ProjectDashboard_Tabs.tracebility,
        ProjectDashboard_Tabs.csat,
        ProjectDashboard_Tabs.defect
    ]);






    const handleChangeProjectDashboard = (event, newValue) => {
        setActiveDashboardModule(newValue);
    }


    const handleComponent = (value) => {
        switch (value) {
            case ProjectDashboard_Tabs.overview: return <ProjectOverView />;
            case ProjectDashboard_Tabs.counters: return <ProjectCounters />;
            default: return <>Coming Soon</>
        }
    }

    useEffect(() => {
        setActiveDashboardModule(tabsList[0])
    }, [tabsList, setActiveDashboardModule]);

    return (
        <Box className="flex-1 flex flex-col gap-4 overflow-hidden">

            {/* header tabs  */}
            <Box className="flex items-center justify-between gap-4 min-h-fit max-h-fit overflow-hidden">

                <Box className="flex items-center gap-4 overflow-hidden">
                    <Tabs
                        // centered
                        variant="scrollable"
                        scrollButtons={false}
                        selectionFollowsFocus
                        textColor="secondary"
                        indicatorColor="secondary"

                        value={activeDashboardModule}
                        onChange={handleChangeProjectDashboard}
                    >
                        {tabsList?.map((label, index) => (
                            <Tab key={index} value={label} label={label} />
                        ))}
                    </Tabs>
                </Box>


                <CalenderRangeButton selectedDate={selectedDate} setSelectedDate={setSelectedDate} />



            </Box>

            {/* main container */}
            <Box className="flex-1 flex flex-col overflow-y-auto">
                {handleComponent(activeDashboardModule)}
            </Box>
        </Box>

    )

}
